var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"align-right"},[_c('Button',{staticClass:"button-style validation-button left-side-button",attrs:{"type":"success"},on:{"click":_vm.processHardware}},[_vm._v(" "+_vm._s(_vm.$t('confirm'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }